import React from 'react'
import GaugeChart from 'react-gauge-chart'

/**
 * Clamp gauge percent to a finite 0–1 value so the gauge
 * does not emit invalid SVG paths when strategy targets are
 * all zero / undefined (0/0 → NaN).
 */
export function sanitizeGaugePercent(percent) {
  const n = Number(percent)
  if (!Number.isFinite(n)) return 0
  if (n < 0) return 0
  if (n > 1) return 1
  return n
}

export default function SafeGaugeChart({ percent, ...props  }) {
  return <GaugeChart {...props} percent={sanitizeGaugePercent(percent)} />
}
